import React from "react";

export default class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false, error: null };
    }

    static getDerivedStateFromError(error) {
        return { hasError: true, error };
    }

    componentDidCatch(error, info) {
        console.error("[ErrorBoundary]", error, info);
    }

    render() {
        if (this.state.hasError) {
            return (
                <div
                    style={{
                        minHeight: "100vh",
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        justifyContent: "center",
                        fontFamily: "Tajawal, sans-serif",
                        direction: "rtl",
                        background: "#f8fafc",
                        padding: "2rem",
                    }}
                >
                    <div
                        style={{
                            background: "#fff",
                            borderRadius: "1.5rem",
                            padding: "2.5rem 3rem",
                            boxShadow: "0 4px 24px rgba(0,0,0,0.08)",
                            maxWidth: "480px",
                            width: "100%",
                            textAlign: "center",
                        }}
                    >
                        <div style={{ fontSize: "3rem", marginBottom: "1rem" }}>⚠️</div>
                        <h2
                            style={{
                                fontSize: "1.4rem",
                                fontWeight: "700",
                                color: "#1e293b",
                                marginBottom: "0.75rem",
                            }}
                        >
                            حدث خطأ غير متوقع
                        </h2>
                        <p style={{ color: "#64748b", marginBottom: "1.5rem", fontSize: "0.95rem" }}>
                            نعتذر عن هذا الخطأ. يرجى تحديث الصفحة أو العودة للرئيسية.
                        </p>
                        <div style={{ display: "flex", gap: "0.75rem", justifyContent: "center" }}>
                            <button
                                onClick={() => window.location.reload()}
                                style={{
                                    background: "#2563eb",
                                    color: "#fff",
                                    border: "none",
                                    borderRadius: "0.75rem",
                                    padding: "0.6rem 1.5rem",
                                    fontWeight: "700",
                                    cursor: "pointer",
                                    fontSize: "0.9rem",
                                }}
                            >
                                تحديث الصفحة
                            </button>
                            <a
                                href="/"
                                style={{
                                    background: "#f1f5f9",
                                    color: "#334155",
                                    borderRadius: "0.75rem",
                                    padding: "0.6rem 1.5rem",
                                    fontWeight: "700",
                                    fontSize: "0.9rem",
                                    textDecoration: "none",
                                }}
                            >
                                الرئيسية
                            </a>
                        </div>
                    </div>
                </div>
            );
        }

        return this.props.children;
    }
}
